import {
    ApolloClient,
    ApolloProvider,
    NormalizedCacheObject,
} from '@apollo/client'
import {
    AuthContext,
    IAuthContext,
} from '@deltek/specification-client/core/Configurations/AuthContext'
import { getApolloBaseClient } from '@deltek/specification-client/core/Configurations/apolloBaseClient'
import { CachePersistor } from 'apollo-cache-persist'
import typePolicies from 'api/graphQL/policies/main.policies'
import resolvers from 'api/graphQL/resolvers/main.resolvers'
import { cacheWatcher } from 'components/configuration/ApolloCacheWatcher'
import React, { useContext, useEffect, useState } from 'react'
import { processEnv } from './environmentVariables'
const ApolloConfiguration: React.FC = ({ children }) => {
    const { getToken } = useContext<IAuthContext>(AuthContext)
    const [client, setClient] = useState<
        ApolloClient<NormalizedCacheObject> | undefined
    >()
    const [persistor, setPersistor] = useState<
        CachePersistor<unknown> | undefined
    >()

    useEffect(() => {
        if (!!client) return
        getApolloBaseClient({
            graphQLUri: processEnv.REACT_APP_GraphQLUri,
            resolvers,
            typePolicies,
        })
            .then((response) => {
                if (!response) return
                setClient(response.client)
                setPersistor(response.persistor)
            })
    }, [client, getToken])

    if (!(client && persistor)) return null

    cacheWatcher(client, persistor)

    return <ApolloProvider client={client}>{children}</ApolloProvider>
}

export default ApolloConfiguration
